import { useEffect } from 'react'
import { THEMES } from '../components/Themes/themes.js'

const SCALAR_RE = /^#|^rgb|^hsl|^var\(/   // detect single-color values for theme-color meta

export function applyTheme(theme) {
  const t = THEMES[theme] || THEMES.hunter
  const root = document.documentElement
  root.setAttribute('data-theme', t.id)

  // Wipe previous vars first so theme switches don't keep stale vals.
  ;['--bg','--fg','--card-bg','--card-border','--card-blur','--accent','--accent-fg',
    '--muted','--radius','--font-display','--font-body','--glow','--shadow',
  ].forEach((k) => root.style.removeProperty(k))

  for (const [k, v] of Object.entries(t.vars)) {
    root.style.setProperty(k, v)
  }

  // <meta name="theme-color"> — only set if bg is a scalar color (status-bar tint).
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    const bg = t.vars['--bg']
    meta.setAttribute('content', SCALAR_RE.test(bg) ? bg : '#020812')
  }
}

export function useTheme(theme) {
  useEffect(() => { if (theme) applyTheme(theme) }, [theme])
}
